import { inject, Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, filter, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpeedLifecycleService {
  private ngZone: NgZone = inject(NgZone);
  private lcpReached$ = new BehaviorSubject<boolean>(false);

  // Observable that components can subscribe to
  public onLcpReady$ = this.lcpReached$.asObservable().pipe(
    filter((ready) => ready === true),
    take(1),
  );

  constructor() {
    this.initLcpObserver();
  }

  private initLcpObserver() {
    // We run this outside Angular's zone so it doesn't trigger unnecessary Change Detection
    this.ngZone.runOutsideAngular(() => {
      const observer = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        const lastEntry = entries[entries.length - 1];

        if (lastEntry) {
          this.ngZone.run(() => {
            this.lcpReached$.next(true);
          });
        }
      });

      observer.observe({ type: 'largest-contentful-paint', buffered: true });
    });
  }
}
